// extracted by mini-css-extract-plugin
export var header = "_wc-1";
export var maskBottom = "_wc-6";
export var maskMiddle = "_wc-7";
export var maskTop = "_wc-5";
export var root = "_wc-0";
export var scrollDownButton = "_wc-3";
export var scrollDownButtonHidden = "_wc-4";
export var viewport = "_wc-2";